module.exports = __webpack_public_path__ + "img/box_anim_bk3.e48c4830.png";